if (!customElements.get('pupmd-countdown-v2')) {
  class PupmdCountdownV2 extends HTMLElement {
    static storageKey = 'pupmd-countdown-v2-deadline';

    /** @type {number} */
    static sharedDeadline = 0;

    /** @type {ReturnType<typeof setInterval> | null} */
    #interval = null;

    /** @type {number} */
    #durationMs = 0;

    /** @type {number} */
    #randomMs = 0;

    /** @param {number} durationMs @param {number} randomMs */
    static getDeadline(durationMs, randomMs) {
      const now = Date.now();

      if (PupmdCountdownV2.sharedDeadline <= now) {
        let storedDeadline = 0;
        try {
          storedDeadline = Number(sessionStorage.getItem(PupmdCountdownV2.storageKey)) || 0;
        } catch {}

        const randomExtraMs = Math.floor(Math.random() * (randomMs / 1000 + 1)) * 1000;
        PupmdCountdownV2.sharedDeadline = storedDeadline > now ? storedDeadline : now + durationMs + randomExtraMs;

        try {
          sessionStorage.setItem(PupmdCountdownV2.storageKey, String(PupmdCountdownV2.sharedDeadline));
        } catch {}
      }

      return PupmdCountdownV2.sharedDeadline;
    }

    connectedCallback() {
      const hours = Number(this.dataset.hours) || 0;
      const minutes = Number(this.dataset.minutes) || 0;
      const seconds = Number(this.dataset.seconds) || 0;

      this.#durationMs = (hours * 3600 + minutes * 60 + seconds) * 1000;
      this.#randomMs = (Number(this.dataset.randomMinutes) || 0) * 60000;
      if (this.#durationMs <= 0) return;

      const compactDisplay = this.querySelector('[data-countdown-compact]');
      const hoursDisplay = this.querySelector('[data-countdown-hours]');
      const minutesDisplay = this.querySelector('[data-countdown-minutes]');
      const secondsDisplay = this.querySelector('[data-countdown-seconds]');

      if (!(compactDisplay instanceof HTMLElement) && (!hoursDisplay || !minutesDisplay || !secondsDisplay)) {
        return;
      }

      const hourLabel = this.dataset.hourLabel || 'h';
      const minuteLabel = this.dataset.minuteLabel || 'min';
      const secondLabel = this.dataset.secondLabel || 'sec';

      const tick = () => {
        const deadline = PupmdCountdownV2.getDeadline(this.#durationMs, this.#randomMs);
        const remainingSeconds = Math.max(Math.ceil((deadline - Date.now()) / 1000), 0);
        const hoursText = String(Math.floor(remainingSeconds / 3600)).padStart(2, '0');
        const minutesText = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
        const secondsText = String(remainingSeconds % 60).padStart(2, '0');

        if (compactDisplay instanceof HTMLElement) {
          compactDisplay.textContent = `${hoursText}${hourLabel} : ${minutesText}${minuteLabel} : ${secondsText}${secondLabel}`;
        } else if (
          hoursDisplay instanceof HTMLElement &&
          minutesDisplay instanceof HTMLElement &&
          secondsDisplay instanceof HTMLElement
        ) {
          hoursDisplay.textContent = hoursText;
          minutesDisplay.textContent = minutesText;
          secondsDisplay.textContent = secondsText;
        }
      };

      tick();
      this.#interval = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      if (this.#interval !== null) {
        clearInterval(this.#interval);
        this.#interval = null;
      }
    }
  }

  customElements.define('pupmd-countdown-v2', PupmdCountdownV2);
}
